export default __webpack_public_path__ + "static/media/evatest.3e539499.jpg";